import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TextField,
  InputAdornment,
  CircularProgress,
  Alert,
  Box,
  Pagination,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
  Stack,
  useTheme,
  useMediaQuery,
  Menu,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Badge,
  TablePagination,
  FormControl,
  InputLabel,
  Select,
  Grid,
  Switch
} from "@mui/material";
import {
  Visibility,
  Delete,
  Phone,
  Search,
  Add,
  FilterList,
  ViewColumn,
  Clear,
  Refresh
} from "@mui/icons-material";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import { getWithTokenAPI, deleteWithTokenAPI, putWithTokenAPI } from '../../util/Api';
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { HiOutlineCurrencyRupee } from "react-icons/hi2";
import {

  CardHeader,
  CardActions,

} from "@mui/material";

import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";

// Delete Confirmation Modal Component
const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  userName,
  mobileNumber,
  isLoading
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
    >
      <DialogTitle id="delete-dialog-title" sx={{ textAlign: 'center' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <Box
            sx={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              backgroundColor: 'error.light',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Delete sx={{ color: 'white', fontSize: 24 }} />
          </Box>
        </Box>
        Delete User Profile
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-dialog-description" sx={{ textAlign: 'center' }}>
          Are you sure you want to delete <strong>{userName}</strong> ({mobileNumber})?
          This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', gap: 2, p: 3 }}>
        <Button
          onClick={onClose}
          disabled={isLoading}
          variant="outlined"
          sx={{ minWidth: 100 }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          disabled={isLoading}
          variant="contained"
          color="error"
          sx={{ minWidth: 100 }}
        >
          {isLoading ? <CircularProgress size={20} /> : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};



const UserManagementSection = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const location = useLocation();
  const [userManagementData, setUserManagementData] = useState({
    loading: false,
    error: null,
    profiles: [],
    totalCount: 0,
    currentPage: 1,
    totalPages: 1,
    limit: 10
  });

  console.log(userManagementData.profiles, "userManagementData")
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const { t } = useTranslation();
  // Pagination state
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Enhanced Filter state
  const [filters, setFilters] = useState({
    status: '',
    gender: '',
    maritalStatus: '',
    ageRange: '',
    location: ''
  });

  // Menu states
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [columnsAnchorEl, setColumnsAnchorEl] = useState(null);

  // Advanced Filter Dialog state
  const [filterDialogOpen, setFilterDialogOpen] = useState(false);

  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    userId: null,
    userName: '',
    mobileNumber: '',
    isLoading: false
  });

  // Column visibility state
  const [columnVisibility, setColumnVisibility] = useState({
    serialNumber: true,
    name: true,
    gender: true,
    age: true,
    phone: true,
    maritalStatus: true,
    location: true,
    status: true,
    plan: true,
    pay: true,
    actions: true
  });

  // Fetch user profiles with proper pagination and filtering
  const fetchUserManagementPlans = async (pageNum = 1, limit = rowsPerPage, search = "", filterParams = filters) => {
    setUserManagementData(prev => ({ ...prev, loading: true, error: null }));
    try {
      const token = localStorage.getItem('matrimony_token');
      if (!token) throw new Error("Please login again");

      // Build query parameters
      let queryParams = `page=${pageNum}&limit=${limit}`;

      if (search) {
        queryParams += `&search=${encodeURIComponent(search)}`;
      }

      // Add all active filters
      Object.entries(filterParams).forEach(([key, value]) => {
        if (value && value !== '') {
          queryParams += `&${key}=${encodeURIComponent(value)}`;
        }
      });

      console.log('Fetching users with params:', queryParams);

      const response = await getWithTokenAPI(
        token,
        `/basic-profile/get_all?${queryParams}`
      );
      console.log('API Response:', response);

      if (response.statusCode === 200 && response.data) {
        const { profiles, total, totalPages, page: currentPage, limit: currentLimit } = response.data;

        // Filter out null profiles and ensure profiles is an array
        const validProfiles = Array.isArray(profiles)
          ? profiles.filter(profile => profile !== null && profile !== undefined)
          : [];

        console.log('Filtered profiles count:', validProfiles.length);
        console.log('Pagination Info:', {
          currentPage,
          totalPages,
          total,
          limit: currentLimit,
          profilesCount: validProfiles.length,
          appliedFilters: filterParams
        });

        // Log status distribution for debugging
        if (validProfiles.length > 0) {
          const statusCounts = validProfiles.reduce((acc, profile) => {
            const status = getProfileStatus(profile);
            acc[status] = (acc[status] || 0) + 1;
            return acc;
          }, {});
          console.log('Status distribution in response:', statusCounts);
        }

        setUserManagementData({
          loading: false,
          error: null,
          profiles: validProfiles,
          totalCount: total || 0,
          currentPage: currentPage || pageNum,
          totalPages: totalPages || 1,
          limit: currentLimit || limit
        });

      } else {
        throw new Error(response.message || "Failed to fetch profiles");
      }

    } catch (error) {
      console.error('Error fetching user profiles:', error);
      setUserManagementData(prev => ({
        ...prev,
        loading: false,
        error: error.message || "Failed to load data"
      }));
    }
  };
useEffect(() => {
  const params = new URLSearchParams(location.search);
  const status = params.get("status");

  if (status) {
    const formattedStatus =
      status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();

    const newFilters = {
      ...filters,
      status: formattedStatus,
    };

    setFilters(newFilters);
    setPage(0);

    fetchUserManagementPlans(1, rowsPerPage, searchTerm, newFilters);
  } else {
    fetchUserManagementPlans(1, rowsPerPage);
  }
}, []);
  // Safe data access functions
  const getProfileName = (profile) => {
    if (!profile) return '—';
    return profile.basicProfile?.name || profile.name || '—';
  };

  const getProfileGender = (profile) => {
    if (!profile) return '—';
    return profile.basicProfile?.gender || profile.gender || '—';
  };

  const getProfileAge = (profile) => {
    if (!profile) return '—';
    return profile.basicProfile?.age || profile.age || '—';
  };

  const getProfileMaritalStatus = (profile) => {
    if (!profile) return '—';
    return profile.basicProfile?.maritalStatus || profile.maritalStatus || '—';
  };

  const getProfileLocation = (profile) => {
    if (!profile) return '—';
    return profile.district || profile.basicProfile?.city || '—';
  };

  const getProfilePlan = (profile) => {
    if (!profile) return '—';
    return profile?.subscription?.plan_name || '—';
  };


  const getProfileStatus = (profile) => {
    if (!profile) return 'Unknown';

    // Check multiple possible locations for status
    const status = profile.basicProfile?.status ||
      profile.status ||
      profile.userStatus ||
      'Unknown';

    // Normalize status values
    const normalizedStatus = String(status).trim();

    // Map common status variations
    const statusMap = {
      'active': 'Active',
      'blocked': 'Blocked',
      'inactive': 'Inactive',
      'suspended': 'Suspended',
      'pending': 'Pending'
    };

    return statusMap[normalizedStatus.toLowerCase()] || normalizedStatus || 'Unknown';
  };

  const getProfileMobile = (profile) => {
    if (!profile) return '—';
    return profile.mobile_number || profile.mobileNumber || '—';
  };

  const getProfileUserId = (profile) => {
    if (!profile) return null;
    return profile.user_id || profile._id || null;
  };


  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    // Reset to page 0 when searching
    setPage(0);

    // Clear previous timeout
    if (window.searchTimeout) {
      clearTimeout(window.searchTimeout);
    }

    if (value.trim() === "") {
      setIsSearching(false);
      // When search is empty, fetch all data
      fetchUserManagementPlans(1, rowsPerPage, "", filters);
    } else {
      setIsSearching(true);
      // Set new timeout for search
      window.searchTimeout = setTimeout(() => {
        fetchUserManagementPlans(1, rowsPerPage, value, filters);
      }, 500);
    }
  };

  // Update your API call to ensure it sends the search term correctly
  // const fetchUserManagementPlans = async (pageNum = 1, limit = rowsPerPage, search = "", filterParams = filters) => {
  //   setUserManagementData(prev => ({ ...prev, loading: true, error: null }));
  //   try {
  //     const token = localStorage.getItem('matrimony_token');
  //     if (!token) throw new Error("Please login again");

  //     // Build query parameters
  //     let queryParams = `page=${pageNum}&limit=${limit}`;

  //     // Enhanced search parameter - ensure it's properly encoded
  //     if (search && search.trim() !== "") {
  //       queryParams += `&search=${encodeURIComponent(search.trim())}`;
  //     }

  //     // Add all active filters
  //     Object.entries(filterParams).forEach(([key, value]) => {
  //       if (value && value !== '') {
  //         queryParams += `&${key}=${encodeURIComponent(value)}`;
  //       }
  //     });

  //     console.log('Fetching users with params:', queryParams);

  //     const response = await getWithTokenAPI(
  //       token,
  //       `/basic-profile/get_all?${queryParams}`
  //     );

  //     if (response.statusCode === 200 && response.data) {
  //       const { profiles, total, totalPages, page: currentPage, limit: currentLimit } = response.data;

  //       const validProfiles = Array.isArray(profiles)
  //         ? profiles.filter(profile => profile !== null && profile !== undefined)
  //         : [];

  //       setUserManagementData({
  //         loading: false,
  //         error: null,
  //         profiles: validProfiles,
  //         totalCount: total || 0,
  //         currentPage: currentPage || pageNum,
  //         totalPages: totalPages || 1,
  //         limit: currentLimit || limit
  //       });

  //     } else {
  //       throw new Error(response.message || "Failed to fetch profiles");
  //     }

  //   } catch (error) {
  //     console.error('Error fetching user profiles:', error);
  //     setUserManagementData(prev => ({
  //       ...prev,
  //       loading: false,
  //       error: error.message || "Failed to load data"
  //     }));
  //   }
  // };

  const clearSearch = () => {
    setSearchTerm("");
    setIsSearching(false);
    setPage(0);
    fetchUserManagementPlans(1, rowsPerPage, "", filters);
  };

  // Filter handlers
  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const handleAdvancedFilterClick = () => {
    setFilterDialogOpen(true);
    handleFilterClose();
  };

  const handleFilterChange = (filterType, value) => {
    console.log(`Setting filter: ${filterType} = "${value}"`);

    const newFilters = {
      ...filters,
      [filterType]: value
    };

    setFilters(newFilters);

    // Reset to first page when filtering
    setPage(0);

    // Fetch data with new filter
    fetchUserManagementPlans(1, rowsPerPage, searchTerm, newFilters);
  };

  const handleApplyFilters = () => {
    setFilterDialogOpen(false);
    setPage(0);
    fetchUserManagementPlans(1, rowsPerPage, searchTerm, filters);
  };

  const clearFilters = () => {
    console.log('Clearing all filters');
    const emptyFilters = {
      status: '',
      gender: '',
      maritalStatus: '',
      ageRange: '',
      location: ''
    };

    setFilters(emptyFilters);

    // Reset to first page
    setPage(0);

    // Fetch data without filters
    fetchUserManagementPlans(1, rowsPerPage, searchTerm, emptyFilters);
  };

  // Check if any filter is active
  const hasActiveFilters = () => {
    return Object.values(filters).some(value => value !== '');
  };

  // Get active filter count
  const getActiveFilterCount = () => {
    return Object.values(filters).filter(value => value !== '').length;
  };

  // Column visibility handlers
  const handleColumnsClick = (event) => {
    setColumnsAnchorEl(event.currentTarget);
  };

  const handleColumnsClose = () => {
    setColumnsAnchorEl(null);
  };

  const toggleColumnVisibility = (column) => {
    setColumnVisibility(prev => ({
      ...prev,
      [column]: !prev[column]
    }));
  };

  const resetAllColumns = () => {
    setColumnVisibility({
      serialNumber: true,
      name: true,
      gender: true,
      age: true,
      phone: true,
      maritalStatus: true,
      location: true,
      plan: true,
      status: true,
      pay: true,
      actions: true
    });
  };

  // Pagination handlers - UPDATED for server-side pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    // Convert Material-UI page (0-based) to server page (1-based)
    const serverPage = newPage + 1;
    fetchUserManagementPlans(serverPage, rowsPerPage, searchTerm, filters);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    // Refetch data with new rows per page
    fetchUserManagementPlans(1, newRowsPerPage, searchTerm, filters);
  };

  const [paymentModal, setPaymentModal] = useState({
    isOpen: false,
    userId: null,
    userName: "",
    mobileNumber: "",
    isLoading: false,
    plans: []
  });

  const openPaymentModal = (user) => {
    setPaymentModal(prev => ({
      ...prev,
      isOpen: true,
      userId: user.id,
      userName: user.name,
      mobileNumber: user.mobile,

    }));
  };

  const openDeleteModal = (userId, userName, mobileNumber) => {
    setDeleteModal({
      isOpen: true,
      userId,
      userName,
      mobileNumber,
      isLoading: false
    });
  };

  const closeDeleteModal = () => {
    setDeleteModal({
      isOpen: false,
      userId: null,
      userName: '',
      mobileNumber: '',
      isLoading: false
    });
  };

  const showToast = (message, type = 'success') => {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      background: type === 'success' ? '#10b981' : '#ef4444',
      color: 'white',
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      }
    });

    Toast.fire({
      icon: type,
      title: message
    });
  };
  const handleStatusChange = async (profileId, status) => {
    try {
      const token = localStorage.getItem("matrimony_token");

      const payload = {
        status: status,
      };

      const response = await putWithTokenAPI(
        token,
        `/basic-profile/update?user_id=${profileId}`,
        payload
      );

      if (response.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: `Status updated to ${status}`,
          timer: 1500,
          showConfirmButton: false,
        });
        fetchUserManagementPlans(page + 1, rowsPerPage, searchTerm, filters);

      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update status",
      });
    }
  };

  useEffect(() => {
    const fetchPlan = async () => {
      try {
        const token = localStorage.getItem('matrimony_token');
        const response = await getWithTokenAPI(token, '/subscriptionPlan/get_all');

        if (response.statusCode === 200 || response.success) {
          setPaymentModal(prev => ({
            ...prev,
            plans: response.data   // <-- SET PLANS ARRAY
          }));
        } else {
          throw new Error(response.message || "Failed to fetch subscription plan");
        }
      } catch (error) {
        console.error("Failed to fetch plan:", error);
        alert(error.message || "Failed to fetch plan");
      }
    };
    fetchPlan();
  }, []);


  const deleteUserManagementProfile = async () => {
    const { userId } = deleteModal;
    if (!userId) return;

    setDeleteModal(prev => ({ ...prev, isLoading: true }));

    try {
      const token = localStorage.getItem('matrimony_token');
      const response = await deleteWithTokenAPI(token, `/profile/delete/${userId}`);
      console.log('delete user', response);

      if (response.statusCode === 200 || response.success) {
        closeDeleteModal();
        showToast("User Deleted Successfully")
        // Refresh current page data
        fetchUserManagementPlans(page + 1, rowsPerPage, searchTerm, filters);

      } else {
        throw new Error(response.message || "Failed to delete user profile");
      }
    } catch (error) {
      console.error("Failed to delete user profile:", error);
      setDeleteModal(prev => ({ ...prev, isLoading: false }));
      alert(error.message || "Failed to delete user profile");
    }
  };

  const handlePhoneCall = (phoneNumber) => {
    if (phoneNumber && phoneNumber !== '—') {
      const cleanNumber = phoneNumber.replace(/[^\d+]/g, '');
      if (cleanNumber) {
        window.open(`tel:${cleanNumber}`, '_self');
      }
    }
  };

  const handleCreateNewUser = () => navigate('/admin/user-management/create');
  const handleViewUserProfile = (userId) => {
    if (userId) {
      navigate(`/admin/user-profile/${userId}`);
    }
  };

  const handleEditUserProfile = (userId) => {
    if (userId) {
      navigate(`/admin/user-management/edit/${userId}`);
    }
  };

  useEffect(() => {
  const params = new URLSearchParams(location.search);
  const status = params.get("status");

  if (status) {
    const formattedStatus =
      status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();

    const newFilters = {
      ...filters,
      status: formattedStatus,
    };

    setFilters(newFilters);
    setPage(0);

    fetchUserManagementPlans(1, rowsPerPage, searchTerm, newFilters);
  } else {
    fetchUserManagementPlans(1, rowsPerPage);
  }
}, []);

  const getStatusColor = (status) => {
    const normalizedStatus = String(status).toLowerCase().trim();
    switch (normalizedStatus) {
      case "active":
        return "success";
      case "suspended":
      case "blocked":
        return "error";
      case "inactive":
        return "warning";
      case "pending":
        return "warning";
      default:
        return "default";
    }
  };

  const getStatusBadge = (status) => {
    const normalizedStatus = String(status).trim();
    return (
      <Chip
        label={normalizedStatus || "Unknown"}
        color={getStatusColor(status)}
        size="small"
        variant="filled"
      />
    );
  };

  // Debug function to check status filtering
  const debugStatusFiltering = () => {
    if (userManagementData.profiles.length > 0) {
      const statusCounts = userManagementData.profiles.reduce((acc, profile) => {
        const status = getProfileStatus(profile);
        acc[status] = (acc[status] || 0) + 1;
        return acc;
      }, {});
      console.log('Current profiles status distribution:', statusCounts);
      console.log('Applied filters:', filters);
    }
  };

  useEffect(() => {
    fetchUserManagementPlans(1, rowsPerPage);
  }, []);

  // Debug when profiles or filters change
  useEffect(() => {
    debugStatusFiltering();
  }, [userManagementData.profiles, filters]);

  // Calculate visible columns for responsive design
  const visibleColumns = Object.entries(columnVisibility)
    .filter(([_, isVisible]) => isVisible)
    .map(([key]) => key);

  const visibleColumnsCount = visibleColumns.length;

  // Advanced Filter Dialog Component
  const AdvancedFilterDialog = () => (
    <Dialog
      open={filterDialogOpen}
      onClose={() => setFilterDialogOpen(false)}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Advanced Filters</Typography>
          <Button
            onClick={clearFilters}
            color="error"
            size="small"
          >
            Clear All
          </Button>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <Grid container spacing={3}>
            {/* Status Filter */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth size="small">
                <InputLabel>Status</InputLabel>
                <Select
                  value={filters.status}
                  label="Status"
                  onChange={(e) => handleFilterChange('status', e.target.value)}
                >
                  <MenuItem value="">All Status</MenuItem>
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                  <MenuItem value="Blocked">Blocked</MenuItem>
                  <MenuItem value="Pending">Pending</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Gender Filter */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth size="small">
                <InputLabel>Gender</InputLabel>
                <Select
                  value={filters.gender}
                  label="Gender"
                  onChange={(e) => handleFilterChange('gender', e.target.value)}
                >
                  <MenuItem value="">All Gender</MenuItem>
                  <MenuItem value="Male">Male</MenuItem>
                  <MenuItem value="Female">Female</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Marital Status Filter */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth size="small">
                <InputLabel>Marital Status</InputLabel>
                <Select
                  value={filters.maritalStatus}
                  label="Marital Status"
                  onChange={(e) => handleFilterChange('maritalStatus', e.target.value)}
                >
                  <MenuItem value="">All Marital Status</MenuItem>
                  <MenuItem value="Single">Single</MenuItem>
                  <MenuItem value="Married">Married</MenuItem>
                  <MenuItem value="Divorced">Divorced</MenuItem>
                  <MenuItem value="Widowed">Widowed</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Age Range Filter */}
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth size="small">
                <InputLabel>Age Range</InputLabel>
                <Select
                  value={filters.ageRange}
                  label="Age Range"
                  onChange={(e) => handleFilterChange('ageRange', e.target.value)}
                >
                  <MenuItem value="">All Ages</MenuItem>
                  <MenuItem value="18-25">18-25 Years</MenuItem>
                  <MenuItem value="26-35">26-35 Years</MenuItem>
                  <MenuItem value="36-45">36-45 Years</MenuItem>
                  <MenuItem value="46+">46+ Years</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Location Filter */}
            <Grid item xs={12}>
              <FormControl fullWidth size="small">
                <InputLabel>Location</InputLabel>
                <Select
                  value={filters.location}
                  label="Location"
                  onChange={(e) => handleFilterChange('location', e.target.value)}
                >
                  <MenuItem value="">All Locations</MenuItem>
                  <MenuItem value="Delhi">Delhi</MenuItem>
                  <MenuItem value="Mumbai">Mumbai</MenuItem>
                  <MenuItem value="Chennai">Chennai</MenuItem>
                  <MenuItem value="Bangalore">Bangalore</MenuItem>
                  <MenuItem value="Kolkata">Kolkata</MenuItem>
                  <MenuItem value="Hyderabad">Hyderabad</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button
          onClick={() => setFilterDialogOpen(false)}
          variant="outlined"
        >
          Cancel
        </Button>
        <Button
          onClick={handleApplyFilters}
          variant="contained"
        >
          Apply Filters
        </Button>
      </DialogActions>
    </Dialog>
  );


  // Enhanced sorting function
  const handleSort = (column) => {
    const isAsc = orderBy === column && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(column);
  };

  // Enhanced sortData function
  const sortData = (array) => {
    if (!array || !Array.isArray(array)) return [];

    return [...array].sort((a, b) => {
      let aValue = "";
      let bValue = "";

      switch (orderBy) {
        case "name":
          aValue = (getProfileName(a) || "").toLowerCase();
          bValue = (getProfileName(b) || "").toLowerCase();
          break;

        case "age":
          aValue = parseInt(getProfileAge(a)) || 0;
          bValue = parseInt(getProfileAge(b)) || 0;
          break;

        case "gender":
          aValue = (getProfileGender(a) || "").toLowerCase();
          bValue = (getProfileGender(b) || "").toLowerCase();
          break;

        case "location":
          aValue = (getProfileLocation(a) || "").toLowerCase();
          bValue = (getProfileLocation(b) || "").toLowerCase();
          break;

        case "maritalStatus":
          aValue = (getProfileMaritalStatus(a) || "").toLowerCase();
          bValue = (getProfileMaritalStatus(b) || "").toLowerCase();
          break;

        case "phone":
          aValue = (getProfileMobile(a) || "").toLowerCase();
          bValue = (getProfileMobile(b) || "").toLowerCase();
          break;

        default:
          return 0;
      }

      if (order === "asc") {
        return aValue < bValue ? -1 : aValue > bValue ? 1 : 0;
      } else {
        return aValue > bValue ? -1 : aValue < bValue ? 1 : 0;
      }
    });
  };

  // Get sorted profiles
  const sortedProfiles = sortData(userManagementData.profiles);

  return (
    <Box sx={{ p: 3 }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Stack
          direction={isMobile ? "column" : "row"}
          justifyContent="space-between"
          alignItems={isMobile ? "stretch" : "center"}
          spacing={2}
        >
          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
            {t("userManagement.userProfiles")}
          </Typography>

          <Button
            onClick={handleCreateNewUser}
            variant="contained"
            startIcon={<Add />}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              background:
                "linear-gradient(to right bottom, rgb(220, 38, 38), rgb(243, 67, 67))",

              minWidth: isMobile ? '100%' : 'auto'
            }}
          >
            {t("userManagement.createNewUser")}
          </Button>
        </Stack>
      </Box>

      {/* Main Card */}
      <Card className="shadow-sm border" sx={{ width: '100%' }}>
        <CardContent className="p-0" sx={{ width: '100%' }}>
          {/* Search and Filter Section */}
          <div className="p-4 border-b border-gray-200 bg-white" style={{ width: '100%' }}>
            <div className="flex flex-col sm:flex-row gap-4 items-center justify-between" style={{ width: '100%' }}>
              {/* Search Bar */}
              <div className="flex-1 w-full sm:max-w-md">
                <TextField
                  fullWidth
                  size="small"
                  placeholder={t("userManagement.searchPlaceholder")}
                  value={searchTerm}
                  onChange={handleSearch}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search className="text-gray-400" />
                      </InputAdornment>
                    ),
                    endAdornment: searchTerm && (
                      <InputAdornment position="end">
                        <IconButton
                          size="small"
                          onClick={clearSearch}
                          className="text-gray-400 hover:text-gray-600"
                        >
                          <Clear className="w-4 h-4" />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '8px',
                      width: "400px"
                    }
                  }}
                />
              </div>

              {/* Action Buttons */}
              <div className="flex gap-2">
                {/* Filter Button with Badge */}
                <DialogContent>
                  <Grid container spacing={3} sx={{ mt: 1 }}>

                    <Grid item xs={12} md={4}>
                      <FormControl fullWidth size="small"  sx={{ width: "100px" }}>
                        <InputLabel>Status</InputLabel>
                        <Select
                          value={filters.status}
                          label="Status"
                          onChange={(e) => handleFilterChange("status", e.target.value)}
                        >
                          <MenuItem value="">All Status</MenuItem>
                          <MenuItem value="Active">Active</MenuItem>
                          <MenuItem value="Inactive">Inactive</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <FormControl fullWidth size="small" sx={{ width: "100px" }}>
                        <InputLabel>Gender</InputLabel>
                        <Select
                          value={filters.gender}
                          label="Gender"
                          onChange={(e) => handleFilterChange("gender", e.target.value)}
                        >
                          <MenuItem value="">All Gender</MenuItem>
                          <MenuItem value="Male">Male</MenuItem>
                          <MenuItem value="Female">Female</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <FormControl fullWidth size="small" sx={{ width: "125px" }}>
                        <InputLabel>Marital Status</InputLabel>
                        <Select
                          value={filters.maritalStatus}
                          label="Marital Status"
                          onChange={(e) => handleFilterChange("maritalStatus", e.target.value)}
                        >
                          <MenuItem value="">All</MenuItem>
                          <MenuItem value="Single">Single</MenuItem>
                          <MenuItem value="Married">Married</MenuItem>
                          <MenuItem value="Divorced">Divorced</MenuItem>
                          <MenuItem value="Widowed">Widowed</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>


                    {/* <Grid item xs={12} md={4}>
                      <FormControl fullWidth size="small" sx={{ width: "100px" }}>
                        <InputLabel>Location</InputLabel>
                        <Select
                          value={filters.location}
                          label="Location"
                          onChange={(e) => handleFilterChange("location", e.target.value)}
                        >
                          <MenuItem value="">All Locations</MenuItem>
                          <MenuItem value="Chennai">Chennai</MenuItem>
                          <MenuItem value="Madurai">Madurai</MenuItem>
                          <MenuItem value="Coimbatore">Coimbatore</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid> */}

                  </Grid>
                </DialogContent>

                {/* Columns Button */}
                <Tooltip title={t("userManagement.showHideColumns")}>
                  <IconButton
                    onClick={handleColumnsClick}
                    className="border border-gray-300"
                  >
                    <ViewColumn />
                  </IconButton>
                </Tooltip>

                {/* Refresh Button */}
                <Tooltip title={t("userManagement.refresh")}>
                  <IconButton
                    onClick={() => fetchUserManagementPlans(page + 1, rowsPerPage, searchTerm, filters)}
                    className="border border-gray-300"
                  >
                    <Refresh />
                  </IconButton>
                </Tooltip>
              </div>
            </div>

            {/* Active Filter Display */}
            {hasActiveFilters() && (
              <div className="mt-3 flex flex-wrap gap-2 items-center">
                <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 'medium' }}>
                  {t("userManagement.activeFilters")}
                </Typography>
                {Object.entries(filters).map(([key, value]) => {
                  if (value && value !== '') {
                    return (
                      <Chip
                        key={key}
                        label={`${key}: ${value}`}
                        size="small"
                        onDelete={() => handleFilterChange(key, '')}
                        color="primary"
                        variant="outlined"
                      />
                    );
                  }
                  return null;
                })}
                <Button
                  onClick={clearFilters}
                  size="small"
                  sx={{
                    textTransform: 'none',
                    color: 'error.main',
                    '&:hover': {
                      backgroundColor: 'rgba(211, 47, 47, 0.04)'
                    }
                  }}
                >
                  {t("userManagement.clearAll")}
                </Button>
              </div>
            )}
          </div>

          {userManagementData.loading ? (
            <div className="p-4 space-y-4">
              <div className="flex space-x-4 border-b pb-4">
                <div className="skeleton h-4 w-12"></div>
                <div className="skeleton h-4 w-48"></div>
                <div className="skeleton h-4 w-20"></div>
                <div className="skeleton h-4 w-20"></div>
                <div className="skeleton h-4 w-32"></div>
                <div className="skeleton h-4 w-32"></div>
                <div className="skeleton h-4 w-24"></div>
                <div className="skeleton h-4 w-24"></div>
                <div className="skeleton h-4 w-24"></div>
                <div className="skeleton h-4 w-24"></div>
                <div className="skeleton h-4 w-24"></div>
                <div className="skeleton h-4 w-24"></div>
                <div className="skeleton h-4 w-24"></div>
                <div className="skeleton h-4 w-24"></div>
              </div>
              {[...Array(10)].map((_, i) => (
                <div key={i} className="flex space-x-4 py-2 border-b border-gray-100 items-center">
                  <div className="skeleton h-4 w-12"></div>
                  <div className="skeleton h-4 w-48"></div>
                  <div className="skeleton h-4 w-20"></div>
                  <div className="skeleton h-4 w-20"></div>
                  <div className="skeleton h-4 w-32"></div>
                  <div className="skeleton h-4 w-32"></div>
                  <div className="skeleton h-4 w-24"></div>
                  <div className="skeleton h-4 w-24"></div>
                  <div className="skeleton h-4 w-24"></div>
                  <div className="skeleton h-4 w-24"></div>
                  <div className="skeleton h-4 w-24"></div>
                  <div className="skeleton h-4 w-24"></div>
                  <div className="skeleton h-4 w-24"></div>
                  <div className="skeleton h-4 w-24"></div>
                </div>
              ))}
            </div>
          ) : userManagementData.error ? (
            <div className="flex justify-center items-center h-40">
              <Alert severity="error" sx={{ width: '100%', maxWidth: 400 }}>
                {userManagementData.error}
              </Alert>
            </div>
          ) : (
            <TableContainer component={Paper} elevation={0} sx={{ width: '100%' }}>
              <Table sx={{ width: '100%' }} size="small">
                <TableHead>
                  <TableRow sx={{ backgroundColor: '#f8f9fa' }}>
                    {columnVisibility.serialNumber && (
                      <TableCell sx={{ fontWeight: '600', fontSize: '0.900rem', py: 2, width: '5%' }}>
                        {t("userManagement.sno")}
                      </TableCell>
                    )}

                    {columnVisibility.name && (
                      <TableCell
                        sortDirection={orderBy === "name" ? order : false}
                        onClick={() => handleSort("name")}
                        sx={{
                          fontWeight: '600',
                          fontSize: '0.900rem',
                          py: 2,
                          width: '20%',
                          cursor: 'pointer',
                          '&:hover': { backgroundColor: '#f0f0f0' }
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          {t("userManagement.name")}
                          {orderBy === "name" && (
                            <Box sx={{ ml: 1 }}>
                              {order === "asc" ? "↑" : "↓"}
                            </Box>
                          )}
                        </Box>
                      </TableCell>
                    )}

                    {columnVisibility.gender && (
                      <TableCell
                        sortDirection={orderBy === "gender" ? order : false}
                        onClick={() => handleSort("gender")}
                        sx={{
                          fontWeight: '600',
                          fontSize: '0.900rem',
                          py: 2,
                          width: '8%',
                          cursor: 'pointer',
                          '&:hover': { backgroundColor: '#f0f0f0' }
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          {t("userManagement.gender")}
                          {orderBy === "gender" && (
                            <Box sx={{ ml: 1 }}>
                              {order === "asc" ? "↑" : "↓"}
                            </Box>
                          )}
                        </Box>
                      </TableCell>
                    )}

                    {columnVisibility.age && (
                      <TableCell
                        sortDirection={orderBy === "age" ? order : false}
                        onClick={() => handleSort("age")}
                        sx={{
                          fontWeight: '600',
                          fontSize: '0.900rem',
                          py: 2,
                          width: '7%',
                          cursor: 'pointer',
                          '&:hover': { backgroundColor: '#f0f0f0' }
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          {t("userManagement.age")}
                          {orderBy === "age" && (
                            <Box sx={{ ml: 1 }}>
                              {order === "asc" ? "↑" : "↓"}
                            </Box>
                          )}
                        </Box>
                      </TableCell>
                    )}

                    {columnVisibility.phone && (
                      <TableCell
                        sortDirection={orderBy === "phone" ? order : false}
                        onClick={() => handleSort("phone")}
                        sx={{
                          fontWeight: '600',
                          fontSize: '0.900rem',
                          py: 2,
                          width: '12%',
                          textAlign: "center",
                          cursor: 'pointer',
                          '&:hover': { backgroundColor: '#f0f0f0' }
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          {t("userManagement.phone")}
                          {orderBy === "phone" && (
                            <Box sx={{ ml: 1 }}>
                              {order === "asc" ? "↑" : "↓"}
                            </Box>
                          )}
                        </Box>
                      </TableCell>
                    )}

                    {columnVisibility.maritalStatus && (
                      <TableCell
                        sortDirection={orderBy === "maritalStatus" ? order : false}
                        onClick={() => handleSort("maritalStatus")}
                        sx={{
                          fontWeight: '600',
                          fontSize: '0.900rem',
                          py: 2,
                          width: '12%',
                          cursor: 'pointer',
                          '&:hover': { backgroundColor: '#f0f0f0' }
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          {t("userManagement.maritalStatus")}
                          {orderBy === "maritalStatus" && (
                            <Box sx={{ ml: 1 }}>
                              {order === "asc" ? "↑" : "↓"}
                            </Box>
                          )}
                        </Box>
                      </TableCell>
                    )}

                    {columnVisibility.location && (
                      <TableCell
                        sortDirection={orderBy === "location" ? order : false}
                        onClick={() => handleSort("location")}
                        sx={{
                          fontWeight: '600',
                          fontSize: '0.900rem',
                          py: 2,
                          width: '12%',
                          cursor: 'pointer',
                          '&:hover': { backgroundColor: '#f0f0f0' }
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          {t("userManagement.location")}
                          {orderBy === "location" && (
                            <Box sx={{ ml: 1 }}>
                              {order === "asc" ? "↑" : "↓"}
                            </Box>
                          )}
                        </Box>
                      </TableCell>
                    )}

                    {columnVisibility?.plan && (
                      <TableCell sx={{ fontWeight: '600', fontSize: '0.900rem', py: 2, width: '12%' }}>
                        {t("userManagement.planName")}
                      </TableCell>
                    )}

                    {columnVisibility.status && (
                      <TableCell sx={{ fontWeight: '600', fontSize: '0.900rem', py: 2, width: '10%' }}>
                        {t("userManagement.status")}
                      </TableCell>
                    )}

                    {/* {columnVisibility.pay && (
                      <TableCell sx={{ fontWeight: '600', fontSize: '0.900rem', py: 2, width: '10%' }}>
                        {t("userManagement.payment")}
                      </TableCell>
                    )} */}

                    {columnVisibility.actions && (
                      <TableCell sx={{ fontWeight: '600', fontSize: '0.900rem', py: 2, width: '19%' }}>
                        {t("userManagement.actions")}
                      </TableCell>
                    )}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {sortedProfiles.length === 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={visibleColumnsCount}
                        align="center"
                        sx={{ py: 4 }}
                      >
                        <div className="text-gray-500 text-sm">
                          {searchTerm || hasActiveFilters()
                            ? t("userManagement.noUsersSearch")
                            : t("userManagement.noUsersFound")
                          }
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : (
                    sortedProfiles.map((profile, index) => (
                      <TableRow
                        key={profile?._id || profile?.user_id || index}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                          '&:hover': { backgroundColor: '#f9fafb' }
                        }}
                      >
                        {columnVisibility.serialNumber && (
                          <TableCell sx={{ fontSize: '0.875rem', py: 2 }}>
                            {page * rowsPerPage + index + 1}
                          </TableCell>
                        )}

                        {columnVisibility.name && (
                          <TableCell sx={{ fontSize: '0.875rem', py: 2 }}>
                            <Button
                              onClick={() => handleViewUserProfile(getProfileUserId(profile))}
                              sx={{
                                p: 0,
                                textTransform: 'none',
                                color: 'primary.main',
                                fontWeight: '700',
                                fontSize: '0.875rem',
                                justifyContent: 'flex-start',
                                textAlign: 'left',
                                width: '100%',
                                '&:hover': {
                                  color: 'primary.dark',
                                  backgroundColor: 'transparent',
                                  textDecoration: 'underline'
                                }
                              }}
                            >
                              {getProfileName(profile)}
                            </Button>
                          </TableCell>
                        )}

                        {columnVisibility.gender && (
                          <TableCell sx={{ fontSize: '0.875rem', py: 2 }}>
                            {getProfileGender(profile)}
                          </TableCell>
                        )}

                        {columnVisibility.age && (
                          <TableCell sx={{ fontSize: '0.875rem', py: 2 }}>
                            {getProfileAge(profile)}
                          </TableCell>
                        )}

                        {columnVisibility.phone && (
                          <TableCell sx={{ fontSize: '0.875rem', py: 2 }}>
                            <Stack direction="row" alignItems="center" spacing={1}>

                              {getProfileMobile(profile) !== '—' && (
                                <Tooltip title={t("userManagement.callThisNumber")}>
                                  <IconButton
                                    size="small"
                                    onClick={() => handlePhoneCall(getProfileMobile(profile))}
                                    sx={{
                                      color: 'success.main',
                                      '&:hover': {
                                        color: 'success.dark',
                                        backgroundColor: 'rgba(76, 175, 80, 0.1)',
                                      }
                                    }}
                                  >
                                    <Phone fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              )}
                              <Typography variant="body2" fontSize="0.875rem">
                                {getProfileMobile(profile)}
                              </Typography>
                            </Stack>
                          </TableCell>
                        )}

                        {columnVisibility.maritalStatus && (
                          <TableCell sx={{ fontSize: '0.875rem', py: 2 }}>
                            {getProfileMaritalStatus(profile)}
                          </TableCell>
                        )}

                        {columnVisibility.location && (
                          <TableCell sx={{ fontSize: '0.875rem', py: 2 }}>
                            {getProfileLocation(profile)}
                          </TableCell>
                        )}
                        {columnVisibility?.plan && (
                          <TableCell sx={{ fontSize: '0.875rem', py: 2 }}>
                            {getProfilePlan(profile)}
                          </TableCell>
                        )}


                        {columnVisibility.status && (
                          <TableCell sx={{ py: 2 }}>
                            <Switch
                              checked={profile.status === "Active"}
                              color="success"
                              onChange={(e) =>
                                handleStatusChange(
                                  profile.user_id,
                                  e.target.checked ? "Active" : "Inactive"
                                )
                              }
                            />
                          </TableCell>
                        )}
                        {/* {columnVisibility.pay && (
                          <TableCell sx={{ py: 2 }}>
                            <Tooltip title="Payment">
                              <IconButton
                                onClick={() =>
                                  navigate(`/admin/plan/${profile?.user_id}`, {
                                    state: {
                                      profileName: profile?.name,
                                      profileMobile: profile?.mobile_number,
                                      planname: profile?.subscription?.plan_name
                                    }
                                  })
                                }
                                profile
                                size="small"
                                sx={{
                                  color: "#15803d",
                                  "&:hover": {
                                    backgroundColor: "rgba(21, 128, 61, 0.1)",
                                  },
                                }}
                              >
                                <HiOutlineCurrencyRupee size={25} />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        )} */}

                        {columnVisibility.actions && (
                          <TableCell sx={{ py: 2 }}>
                            <Stack direction="row" spacing={1}>
                              <Tooltip title={t("userManagement.viewProfile")}>
                                <IconButton
                                  onClick={() => handleViewUserProfile(getProfileUserId(profile))}
                                  size="small"
                                  sx={{
                                    color: '#2563eb',
                                    '&:hover': {
                                      backgroundColor: 'rgba(37, 99, 235, 0.1)',
                                    }
                                  }}
                                >
                                  <Visibility fontSize="small" />
                                </IconButton>
                              </Tooltip>

                              <Tooltip title={t("userManagement.editProfile")}>
                                <IconButton
                                  onClick={() => handleEditUserProfile(getProfileUserId(profile))}
                                  size="small"
                                  sx={{
                                    color: '#059669',
                                    '&:hover': {
                                      backgroundColor: 'rgba(5, 150, 105, 0.1)',
                                    }
                                  }}
                                >
                                  <FiEdit size={16} />
                                </IconButton>
                              </Tooltip>

                              <Tooltip title={t("userManagement.deleteProfile")}>
                                <IconButton
                                  onClick={() => openDeleteModal(
                                    getProfileUserId(profile),
                                    getProfileName(profile),
                                    getProfileMobile(profile)
                                  )}
                                  size="small"
                                  sx={{
                                    color: '#dc2626',
                                    '&:hover': {
                                      backgroundColor: 'rgba(220, 38, 38, 0.1)',
                                    }
                                  }}
                                >
                                  <FiTrash2 size={16} />
                                </IconButton>
                              </Tooltip>
                            </Stack>
                          </TableCell>
                        )}
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>

              {/* Material-UI Pagination - UPDATED for server-side */}
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                count={userManagementData.totalCount || 0}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  fontSize: '0.875rem',
                  '& .MuiTablePagination-toolbar': {
                    padding: 2
                  }
                }}
                labelRowsPerPage="Rows per page:"
                labelDisplayedRows={({ from, to, count }) =>
                  t("userManagement.displayedRows", { from, to, count })
                }
              />
            </TableContainer>
          )}
        </CardContent>
      </Card>

      {/* Advanced Filter Dialog */}
      <AdvancedFilterDialog />

      {/* Column Settings Menu */}
      <Menu
        anchorEl={columnsAnchorEl}
        open={Boolean(columnsAnchorEl)}
        onClose={handleColumnsClose}
        PaperProps={{
          sx: { width: 250, maxHeight: 400 }
        }}
      >
        <MenuItem disabled>
          <Typography variant="subtitle2" fontWeight="bold">
            Show/Hide Columns
          </Typography>
        </MenuItem>
        <MenuItem>
          <FormControlLabel
            control={
              <Checkbox
                checked={columnVisibility.serialNumber}
                onChange={() => toggleColumnVisibility('serialNumber')}
              />
            }
            label="S.No"
          />
        </MenuItem>
        <MenuItem>
          <FormControlLabel
            control={
              <Checkbox
                checked={columnVisibility.name}
                onChange={() => toggleColumnVisibility('name')}
              />
            }
            label="Name"
          />
        </MenuItem>
        <MenuItem>
          <FormControlLabel
            control={
              <Checkbox
                checked={columnVisibility.gender}
                onChange={() => toggleColumnVisibility('gender')}
              />
            }
            label="Gender"
          />
        </MenuItem>
        <MenuItem>
          <FormControlLabel
            control={
              <Checkbox
                checked={columnVisibility.age}
                onChange={() => toggleColumnVisibility('age')}
              />
            }
            label="Age"
          />
        </MenuItem>
        <MenuItem>
          <FormControlLabel
            control={
              <Checkbox
                checked={columnVisibility.phone}
                onChange={() => toggleColumnVisibility('phone')}
              />
            }
            label="Phone"
          />
        </MenuItem>
        <MenuItem>
          <FormControlLabel
            control={
              <Checkbox
                checked={columnVisibility.maritalStatus}
                onChange={() => toggleColumnVisibility('maritalStatus')}
              />
            }
            label="Marital Status"
          />
        </MenuItem>
        <MenuItem>
          <FormControlLabel
            control={
              <Checkbox
                checked={columnVisibility.location}
                onChange={() => toggleColumnVisibility('location')}
              />
            }
            label="Location"
          />
        </MenuItem>
        <MenuItem>
          <FormControlLabel
            control={
              <Checkbox
                checked={columnVisibility.status}
                onChange={() => toggleColumnVisibility('status')}
              />
            }
            label="Status"
          />
        </MenuItem>
        <MenuItem>
          <FormControlLabel
            control={
              <Checkbox
                checked={columnVisibility.actions}
                onChange={() => toggleColumnVisibility('actions')}
              />
            }
            label="Actions"
          />
        </MenuItem>
        <MenuItem>
          <Button
            onClick={resetAllColumns}
            variant="outlined"
            size="small"
            fullWidth
            sx={{ textTransform: 'none' }}
          >
            Show All Columns
          </Button>
        </MenuItem>
      </Menu>

      {/* Delete Modal */}
      <DeleteConfirmationModal
        isOpen={deleteModal.isOpen}
        onClose={closeDeleteModal}
        onConfirm={deleteUserManagementProfile}
        userName={deleteModal.userName}
        mobileNumber={deleteModal.mobileNumber}
        isLoading={deleteModal.isLoading}
      />


    </Box>
  );
};

export default UserManagementSection;